<template>
  <div>    

    <table class="table align-items-center mb-0">
      <thead>
        <tr>
          <th class="text-sm">Port</th>
          <th class="text-sm">TX Power (dBm)</th>
          <th class="text-sm">Current (mA)</th>
          <th class="text-sm">Voltage (V)</th>
          <th class="text-sm">Temperature (°C)</th>
          <th class="text-sm">Status</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="loading">
          <tr>
            <td colspan="6">
              <Skalaton />
            </td>
          </tr>
        </template>
        <template v-else-if="hasPonData">
          <tr
            v-for="port in ponInfo.poninfo.optical_transceiver"
            :key="port['Port ID']"
          >
            <td class="text-sm font-weight-bold">{{ port['Port ID'] }}</td>
            <td class="text-sm" :class="getTxPowerClass(port['Transmit Power(dBm)'])">
              {{ formatPower(port['Transmit Power(dBm)']) }}
            </td>
            <td class="text-sm">{{ formatCurrent(port['Bias Current(mA)']) }}</td>
            <td class="text-sm">{{ formatVoltage(port['Voltage(V)']) }}</td>
            <td class="text-sm" :class="getTemperatureClass(port['Temperature(°C)'])">
              {{ formatTemperature(port['Temperature(°C)']) }}
            </td>
            <td class="text-sm">
              <span
                class="badge"
                :class="getStatusClass(port)"
                style="text-transform: uppercase; color: rgb(255 249 249) !important;"
              >
                {{ getStatusText(port) }}
              </span>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="6" class="text-center">
              <div class="text-muted py-4">
                <i class="fas fa-exclamation-circle me-2"></i>
                No PON port data available
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'VsolEponPonTable',
  components: {
    Skalaton
  },
  props: {
    ponInfo: {
      type: Object,
      default: () => ({})
    },
    loading: Boolean
  },
  computed: {
    hasPonData() {
      return this.ponInfo && 
             this.ponInfo.poninfo && 
             this.ponInfo.poninfo.optical_transceiver && 
             this.ponInfo.poninfo.optical_transceiver.length > 0;
    }
  },
  methods: {
    formatPower(value) {
      if (value === null || value === undefined || value === 'N/A') return 'N/A';
      return `${value} dBm`;
    },
    
    formatCurrent(value) {
      if (value === null || value === undefined || value === 'N/A') return 'N/A';
      return `${value} mA`;
    },
    
    formatVoltage(value) {
      if (value === null || value === undefined || value === 'N/A') return 'N/A';
      return `${value} V`;
    },
    
    formatTemperature(value) {
      if (value === null || value === undefined || value === 'N/A') return 'N/A';
      return `${value}°C`;
    },
    
    getTxPowerClass(value) {
      if (value === null || value === undefined || value === 'N/A') return 'text-muted';
      
      const powerValue = parseFloat(value);
      // EPON TX power should be positive (typically 2-9 dBm)
      if (powerValue >= 2 && powerValue <= 9) return 'text-success'; // Normal range
      if (powerValue > 0 && powerValue < 2) return 'text-warning'; // Low but working
      return 'text-danger'; // Out of range
    },
    
    getTemperatureClass(value) {
      if (value === null || value === undefined || value === 'N/A') return 'text-muted';
      
      const tempValue = parseFloat(value);
      if (tempValue < 50) return 'text-success'; // Normal temperature
      if (tempValue < 60) return 'text-warning'; // Warning temperature
      return 'text-danger'; // Critical temperature
    },
    
    getStatusClass(port) {
      // Check if port has valid TX power and is not N/A
      const txPower = port['Transmit Power(dBm)'];
      if (txPower && txPower !== 'N/A' && parseFloat(txPower) > 0) {
        return 'bg-success'; // Active and working
      }
      return 'bg-secondary'; // Inactive
    },
    
    getStatusText(port) {
      // Check if port has valid TX power and is not N/A
      const txPower = port['Transmit Power(dBm)'];
      if (txPower && txPower !== 'N/A' && parseFloat(txPower) > 0) {
        return 'Active';
      }
      return 'Inactive';
    }
  }
}
</script>